import styled from 'styled-components';
import { Form as BaseForm } from 'formik';

import BaseWrapper from 'shared/components/presentational/Wrapper/Wrapper';
import { CustomTitle } from 'shared/components/presentational/Title/sharedTitles';
import { FONT_FAMILIES, FONT_WEIGHTS } from 'shared/constants/theme';

export const Wrapper = styled(BaseWrapper)`
  padding: 0 var(--container-minimum-padding);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
  --title-position: left;
`;

export const Form = styled(BaseForm)`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
`;

export const FieldTitle = styled(CustomTitle)`
  font-family: ${FONT_FAMILIES.base};
  font-weight: ${FONT_WEIGHTS.demi};
  font-size: var(--text-size-h3);
`;

export const AlertBoxContainer = styled.div`
  margin: var(--spacing-l) var(--spacing-m);
`;

export const Tax = styled.div`
  display: flex;
  margin-top: var(--spacing-xs);
  color: var(--text-title);
`;

export const TaxLabel = styled.p`
  margin: 0;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-s);
`;
